var map = {
	"./all": 8753,
	"./all.js": 8753,
	"./books": 8733,
	"./books.js": 8733,
	"./calendars": 5071,
	"./calendars.js": 5071,
	"./delete": 6326,
	"./delete.js": 6326,
	"./discounts": 3761,
	"./discounts.js": 3761,
	"./edit": 7245,
	"./edit.js": 7245,
	"./galleries": 6800,
	"./galleries.js": 6800,
	"./groups": 3529,
	"./groups.js": 3529,
	"./magnets": 8091,
	"./magnets.js": 8091,
	"./processings": 2064,
	"./processings.js": 2064,
	"./show": 7262,
	"./show.js": 7262,
	"./showEdit": 8134,
	"./showEdit.js": 8134,
	"./sizes": 8315,
	"./sizes.js": 8315,
	"./watermarks": 6655,
	"./watermarks.js": 6655
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 444;